import ReactGA from "react-ga4";

const AB_TEST_COOKIES = ["ab_home", "ab_home_ads"];

const isValidEnv = () => {
  if (process.env.REACT_APP_ENV === "prod") {
    return true;
  }
  return false;
};

const getCookie = name => {
  const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
};

const getAbTestUserProperties = () =>
  AB_TEST_COOKIES.reduce((properties, name) => {
    const value = getCookie(name);
    if (value) {
      properties[name] = value;
    }
    return properties;
  }, {});

export const GAWrapperInit = () => {
  if (isValidEnv()) {
    const abTestUserProperties = getAbTestUserProperties();
    if (Object.keys(abTestUserProperties).length) {
      ReactGA.gtag("set", "user_properties", abTestUserProperties);
    }
    ReactGA.initialize([
      {
        trackingId: process.env.REACT_APP_GA_TRACKING_ID
      }
    ]);
  }
};

export const GAWrapperEvent = param => {
  if (param && isValidEnv()) {
    ReactGA.event(param);
  }
};
